import React, { useState, useEffect, useRef } from "react";
import Navbar from "./Navbar";
import ReusableProgessBar from "components/common/ReusableProgessBar";
import DirectionLine from "./DirectionLine";
import { useDispatch, useSelector } from "react-redux";
import { saveEducationalDetails } from "../../../../../src/redux/formActions";
import { goBack } from "../../../../../src/redux/slice/onboardingFormSlice";
import { fetchgetInvitedUserDetailsById } from "../../../../../src/redux/slice/getInvitedUserDetailsSlice";
import { submitAllFormData } from "../../../../../src/redux/formApiActions";
import { toast, ToastContainer } from "react-toastify";
import useUploadPreOnboardingDocs from "../../../../../src/hooks/useUploadPreOnboardingDocs";
import { fetchgetPreOnboardingDocsById } from "../../../../../src/redux/slice/getPreOnboardingDocsByIdSlice";
import clsx from 'clsx';
import { useForm } from "react-hook-form";
import ValidateFile from "../../../../utils/ValidateFile";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";

const fixedDegrees = [
  { label: "10th", required: true },
  { label: "12th", required: true },
  { label: "Graduation", required: false },
  { label: "Post Graduation", required: false },
  { label: "Other", required: false },
];

export default function EducationalDetailsForm() {
  const dispatch = useDispatch();
  const { register, handleSubmit, setValue, watch, trigger, formState: { errors }, unregister } = useForm();
  const [eduRows, setEduRows] = useState(
    fixedDegrees.map((degree) => ({ ...degree, fixed: true })),
  );

  const [openCalendarIndex, setOpenCalendarIndex] = useState(null);
  const [educationalPassYears, setEducationalPassYears] = useState(
    fixedDegrees.map(() => null)
  );

  const [calendarPosition, setCalendarPosition] = useState({
    top: 0,
    left: 0,
  });
  const calendarRefs = useRef([]);
  const educationalDatePickerRef = useRef([]);
  const fileInputRefs = useRef({});
  const [educationalDegreeDoc, setEducationalDegreeDoc] = useState({});

  const [docError, setDocError] = useState({});

  const { handleFileUpload } = useUploadPreOnboardingDocs();
  const InviteData = useSelector(
    (state) => state.persistedReducer.forms.inviteData,
  );
  const paramId = InviteData?.id;
  const { getInvitedUserDetailsById } = useSelector(
    (state) => state.getInvitedUserDetailsById,
  );

  const docs = useSelector((state) => state.getPreOnboardingDocsById.docs);
  const { educationDetails } = getInvitedUserDetailsById ?? {};
  const savedData = educationDetails;

  useEffect(() => {
    dispatch(fetchgetInvitedUserDetailsById(paramId));
  }, []);

  useEffect(() => {
    educationalDatePickerRef.current = eduRows.map(
      (_, index) =>
        educationalDatePickerRef.current[index] || React.createRef(),
    );
  }, [eduRows]);

  useEffect(() => {
    if (savedData?.length) {
      if (savedData.length > eduRows.length) {
        setEduRows((prev) => [
          ...prev,
          ...new Array(savedData.length - prev.length).fill(null).map(() => ({ fixed: false })),
        ]);
        setEducationalPassYears((prev) => [
          ...prev,
          ...new Array(savedData.length - prev.length).fill(null),
        ]);
      }

      savedData.forEach((item, index) => {
        setValue(
          `higherDegreeName_${index}`,
          item.degreeName || eduRows[index]?.label || "",
        );
        setValue(`higherCollegeName_${index}`, item.institutionName || "");
        setValue(`collegeLocation_${index}`, item.location || "");
        setValue(`higherDegreeSubject_${index}`, item.fieldOfStudy || "");
        setValue(`higherDegreeRollNo_${index}`, item.rollNumber || "");
        setValue(`higherDegreeGrade_${index}`, item.gradeOrcgpa || "");
        setValue(`eduDocs_${index}`, item.degreeCertificateUrl || "");
        const savedYear = item.toDate
          ? String(item.toDate).length === 4
            ? Number(item.toDate)
            : new Date(item.toDate).getFullYear()
          : null;
        setValue(`degreePassYear_${index}`, savedYear || "");
        setEducationalPassYears((prev) => {
          const newYears = [...prev];
          newYears[index] = savedYear;
          return newYears;
        });
      });
    }
  }, [savedData, setValue]);

  // Add new row
  const addTableForNextEducationDetail = () => {
    if (eduRows.length < 7) {
      setEduRows((prev) => [...prev, { label: "", fixed: false }]);
      setEducationalPassYears((prev) => [
        ...prev,
        null,
      ]);
    }
  };
  // Remove row
  const removeTableForNextEducationDetail = (index) => {
    if (!eduRows[index].fixed) {
      setEduRows((prev) => prev.filter((_, i) => i !== index));
      setEducationalPassYears((prev) =>
        prev.filter((_, i) => i !== index)
      );
    }
  };

  // File Upload
  const handleFileForEduDocs = async (e, field, index, label) => {
    const safeIndex = String(index);
    const file = e.target.files[0];
    const dynamicField = `${field}_${safeIndex}`;

    if (!file) return;
    const allowedTypes = ["application/pdf", "image/jpg", "image/jpeg", "image/png"];
    const validate = ValidateFile(file, allowedTypes)

    if (validate !== true) {
      toast.error(validate);
      return;
    }
    const previewUrl = file.type.startsWith("image/")
      ? URL.createObjectURL(file)
      : file.name;

    setEducationalDegreeDoc((prev) => ({
      ...prev,
      [dynamicField]: { file, previewUrl },
    }));

    setDocError((prev) => ({
      ...prev,
      [`eduError_${safeIndex}`]: false,
    }));

    let uploadType = "";

    if (index === 0) {
      uploadType = "10thMarksheet";
    } else if (index === 1) {
      uploadType = "12thMarksheet";
    } else {
      const degreeName = watch(`higherDegreeName_${index}`)?.trim() || label;
      uploadType = `${degreeName}Certificate`;
    }

    await handleFileUpload(file, uploadType, paramId);
    dispatch(fetchgetPreOnboardingDocsById({ type: uploadType, id: paramId }));
  };

const handleFormSubmit = (data) => {
  const eduFileErrors = {};
  let isEduFileMissing = false;

  for (let index = 0; index < eduRows.length; index++) {
    const degreeName =
      data[`higherDegreeName_${index}`]?.trim() ||
      eduRows[index]?.label?.trim() ||
      "";

    const passYear = data[`degreePassYear_${index}`];
    const hasFile =
      educationalDegreeDoc[`eduDocs_${index}`]?.file ||
      educationalDegreeDoc[`eduDocs_${index}`]?.previewUrl ||
      docs?.[index === 0
        ? "10thMarksheet"
        : index === 1
          ? "12thMarksheet"
          : `${degreeName}Certificate`];
   
    const isDocumentRequired =
      !!degreeName && !!passYear;

    if (isDocumentRequired && !hasFile) {
      eduFileErrors[`eduError_${index}`] = true;
      isEduFileMissing = true;
    }
  }

  if (isEduFileMissing) {
    setDocError((prev) => ({
      ...prev,
      ...eduFileErrors,
    }));

    toast.error(
      "Please upload all required documents before submitting.",
      {
        className: "toast-error-custom",
        autoClose: 4000,
      }
    );
    return;
  }

  const payload = eduRows.reduce((acc, row, index) => {
    const institution = data[`higherCollegeName_${index}`];
    const degreeName = data[`higherDegreeName_${index}`]?.trim();

    if (degreeName || (institution && institution.trim() !== "")) {
      acc.push({
        degreeName: data[`higherDegreeName_${index}`] || row.label,
        institutionName: institution,
        location: data[`collegeLocation_${index}`],
        fieldOfStudy: data[`higherDegreeSubject_${index}`],
        fromDate: "",
        toDate: data[`degreePassYear_${index}`]
          ? `${data[`degreePassYear_${index}`]}-01-01`
          : "",
        rollNumber: data[`higherDegreeRollNo_${index}`],
        gradeOrcgpa: data[`higherDegreeGrade_${index}`],
      });
    }

    return acc;
  }, []);

  const finalPayload = {
    educationDetails: payload,
    type: "FULL_UPDATE",
    status: "PARTIAL_COMPLETED",
  };

  dispatch(
    submitAllFormData(
      finalPayload,
      paramId,
      "saveandnext"
    )
  );

  dispatch(saveEducationalDetails(payload));
};

  const handleSaveAsDraft = () => {
    const data = watch();
    const payload = eduRows.reduce((acc, row, index) => {
      const institution = data[`higherCollegeName_${index}`];
      const degreeName = data[`higherDegreeName_${index}`]?.trim();

      if (degreeName || (institution && institution.trim() !== "")) {
        acc.push({
          degreeName: data[`higherDegreeName_${index}`] || row.label || "",
          institutionName: data[`higherCollegeName_${index}`] || "",
          location: data[`collegeLocation_${index}`] || "",
          fieldOfStudy: data[`higherDegreeSubject_${index}`] || "",
          fromDate: "",
          toDate: data[`degreePassYear_${index}`]
            ? `${data[`degreePassYear_${index}`]}-01-01`
            : "",

          rollNumber: data[`higherDegreeRollNo_${index}`] || "",
          gradeOrcgpa: data[`higherDegreeGrade_${index}`] || "",
          degreeCertificateUrl:
            educationalDegreeDoc[`eduDocs_${index}`]?.previewUrl || "",
        });
      }
      return acc;
    }, []);

    const finalPayload = {
      educationDetails: payload,
      type: "PARTIAL_UPDATE",
      status: "DRAFT",
    };

    dispatch(submitAllFormData(finalPayload, paramId, "draft"))
      .catch(() => {
        toast.error("Failed to save draft. Please try again.", {
          className: "toast-error-custom",
          autoClose: 4000,
        });
      });
  };

  useEffect(() => {
    educationDetails.map(async (education, index) => {
      let uploadType = "";

      if (index === 0) {
        uploadType = "10thMarksheet";
      } else if (index === 1) {
        uploadType = "12thMarksheet";
      } else {
        uploadType = `${education.degreeName}Certificate`;
      }
      dispatch(
        fetchgetPreOnboardingDocsById({ type: uploadType, id: paramId }),
      );
    });
  }, []);

  useEffect(() => {
    if (docs && Object.keys(docs).length > 0) {
      setEducationalDegreeDoc((prev) => {
        const newState = { ...prev };
        educationDetails.forEach((edu, index) => {
          let uploadType = "";
          if (index === 0) uploadType = "10thMarksheet";
          else if (index === 1) uploadType = "12thMarksheet";
          else uploadType = `${edu.degreeName}Certificate`;
          if (docs[uploadType]) {
            const dynamicField = `eduDocs_${index}`;
            newState[dynamicField] = {
              file: null,
              previewUrl: docs[uploadType],
            };
          }
        });

        return newState;
      });
    }
  }, [docs, dispatch]);
  useEffect(() => {
    return () => {

      eduRows.forEach((_, index) => {
        unregister(`duration_${index}`);
      });
    };
  }, [eduRows, unregister]);
  // console.log('eduRows',eduRows)
  console.log('errors', errors)
  return (
    <div className="wrapper">
      <Navbar />
      <div className="sidebar">
        <div className="sidebar-wrapper">
          <ReusableProgessBar />
        </div>
      </div>
      <div className="main-panel">
        <div className="form-content">
          <div className="container-fluid form-navbar">
            <div className="personaldetail-form">
              <DirectionLine />
              <div className="personalDetailForm">
                <form
                  onSubmit={handleSubmit(handleFormSubmit)}
                  className="edu-form-container">
                  <div className="personalDetailHeading">
                    <h6 className="educationalHeadline">
                      EDUCATIONAL QUALIFICATION
                    </h6>
                  </div>
                  <div className="upload-alert" role="alert">
                    <small className="alert-content">
                      <small className="help-text"><strong>Accepted Formats:</strong> PDF, JPG, JPEG, and PNG only.| Size: 10MB</small>
                    </small>
                  </div>
                  <div className="table-responsive">
                    <table className="table tableWidth table-bordered">
                      <thead>
                        <tr>
                          <th className="tableHead">Degree / Qualification Name</th>
                          <th className="tableHead">College / Institute Name</th>
                          <th className="tableHead">Location</th>
                          <th className="tableHead min-w-200" style={{ width: '220px' }}>Passed Year</th>
                          <th className="tableHead" style={{ width: '140px' }}>Grade / Cgpa</th>
                          <th className="tableHead">Attachments</th>
                        </tr>
                      </thead>
                      <tbody>
                        {eduRows.map((row, index) => {
                          //console.log('eduRows-->>>>>>>', eduRows)
                          const currentDegreeName =
                            watch(`higherDegreeName_${index}`) || "";

                          let uploadType = "";
                          if (index === 0) {
                            uploadType = "10thMarksheet";
                          } else if (index === 1) {
                            uploadType = "12thMarksheet";
                          } else {
                            uploadType = currentDegreeName
                              ? `${currentDegreeName}Certificate`
                              : "";
                          }
                          const degreeNameValue = watch(`higherDegreeName_${index}`);
                          //const isRowRequired = index < 2 || (degreeNameValue && degreeNameValue.trim() !== "");
                          const isRowFilled =
                            watch(`higherDegreeName_${index}`)?.trim() ||
                            watch(`higherCollegeName_${index}`)?.trim() ||
                            watch(`collegeLocation_${index}`)?.trim() ||
                            watch(`higherDegreeSubject_${index}`)?.trim() ||
                            watch(`higherDegreeRollNo_${index}`)?.trim() ||
                            watch(`higherDegreeGrade_${index}`)?.trim();

                          const isRowRequired = index < 2 || !!isRowFilled;
                          return (
                            <tr key={index}>
                              <td className="tableBody">
                                {index === 0 || index === 1 ? (
                                  <div className="requiredDegree">
                                    <input type="text" value={index === 0 ? "10th" : "12th"} readOnly className="addressTableInput" />
                                    <span className="requiredValue">*</span>
                                  </div>
                                ) : (
                                  <input type="text" className="addressTableInput" placeholder={row.label || "Other Degree"} {...register(`higherDegreeName_${index}`)} />
                                )}
                              </td>
                              <td className="tableBody">
                                <input type="text" className={clsx("addressTableInput", { "invalid": errors[`higherCollegeName_${index}`] })}
                                  placeholder={errors[`higherCollegeName_${index}`] ? "⚠ Required" : ""}
                                  {...register(`higherCollegeName_${index}`, {
                                    //required: isRowRequired ? "Required" : false, 
                                    required: false,
                                  })}
                                />
                              </td>
                              <td className="tableBody">
                                <input type="text" placeholder={errors[`collegeLocation_${index}`] ? "⚠ Required" : ""}
                                  className={clsx("addressTableInput", { "invalid": errors[`collegeLocation_${index}`] })}
                                  {...register(`collegeLocation_${index}`, {
                                    //required: isRowRequired ? "Required" : false, 
                                    required: false,
                                  })}
                                />
                              </td>
                              <td className="tableBody" style={{ width: "160px", position: "relative" }}>
                                <div className="date-picker-wrapper" ref={(el) => (calendarRefs.current[index] = el)}>
                                  <div style={{ position: "relative" }}>
                                    <input
                                      type="text"
                                      readOnly
                                      value={educationalPassYears[index] || ""}
                                      placeholder={
                                        errors[`degreePassYear_${index}`]
                                          ? "⚠ Required"
                                          : "Select Pass Year"
                                      }
                                      className={clsx(
                                        "addressTableInput cursor-pointer",
                                        {
                                          invalid: errors[`degreePassYear_${index}`],
                                        }
                                      )}
                                      {...register(`degreePassYear_${index}`, {
                                        required: isRowRequired ? "Required" : false,
                                        //required: false,
                                      })}
                                      onClick={(e) => {
                                        const rect = e.target.getBoundingClientRect();
                                        const calendarHeight = 320;
                                        const calendarWidth = 300;
                                        let top = rect.bottom + 5;
                                        let left = rect.left;

                                        if (
                                          window.innerHeight - rect.bottom <
                                          calendarHeight
                                        ) {
                                          top = rect.top - calendarHeight - 5;
                                        }

                                        if (
                                          window.innerWidth - rect.left <
                                          calendarWidth
                                        ) {
                                          left =
                                            window.innerWidth -
                                            calendarWidth -
                                            10;
                                        }

                                        setCalendarPosition({ top, left });

                                        setOpenCalendarIndex(
                                          openCalendarIndex === index ? null : index
                                        );
                                      }}
                                    />

                                    {educationalPassYears[index] && (
                                      <span className="close-calendra"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const newYears = [
                                            ...educationalPassYears,
                                          ];
                                          newYears[index] = null;
                                          setEducationalPassYears(newYears);
                                          setValue(
                                            `degreePassYear_${index}`,
                                            "",
                                            {
                                              shouldValidate: true,
                                            }
                                          );
                                        }}
                                      >
                                        ✕
                                      </span>
                                    )}
                                  </div>

                                  {openCalendarIndex === index && (
                                    <>
                                      <div onClick={() => setOpenCalendarIndex(null)}
                                        style={{
                                          position: "fixed",
                                          top: 0,
                                          left: 0,
                                          width: "100vw",
                                          height: "100vh",
                                          zIndex: 9998,
                                        }}
                                      />

                                      <div className="datePicker-calendra"
                                        style={{
                                          position: "fixed",
                                          top: calendarPosition.top,
                                          left: calendarPosition.left,
                                          zIndex: 999999,
                                        }}
                                        onMouseDown={(e) => e.stopPropagation()}
                                      >
                                        <div style={{
                                          display: "grid",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          gap: "8px",
                                          padding: "12px",
                                          maxHeight: "220px",
                                          overflowY: "auto",
                                        }}>
                                          {Array.from(
                                            { length: new Date().getFullYear() - 1970 + 1 },
                                            (_, i) => new Date().getFullYear() - i
                                          ).map((year) => (
                                            <button
                                              key={year}
                                              type="button"
                                              onClick={() => {
                                                const newYears = [...educationalPassYears];
                                                newYears[index] = year;
                                                setEducationalPassYears(newYears);
                                                setValue(`degreePassYear_${index}`, year, {
                                                  shouldValidate: true,
                                                  shouldDirty: true,
                                                });
                                                setOpenCalendarIndex(null);
                                              }}
                                              style={{
                                                padding: "8px 4px",
                                                border: "1px solid #ddd",
                                                borderRadius: "6px",
                                                background:
                                                  educationalPassYears[index] === year
                                                    ? "#e8f0fe"
                                                    : "#fff",
                                                cursor: "pointer",
                                              }}
                                            >
                                              {year}
                                            </button>
                                          ))}
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </td>
                              <td className="tableBody">
                                <input type="text" className={clsx("addressTableInput", { "invalid": errors[`higherDegreeGrade_${index}`] })}
                                  placeholder={errors[`higherDegreeGrade_${index}`] ? "⚠ Required" : ""}
                                  {...register(`higherDegreeGrade_${index}`, {
                                    //required: isRowRequired ? "Required" : false,
                                    required: false,
                                  })}
                                />
                              </td>
                              <td className="tableBody">
                                <input key={index} type="file"
                                  onChange={(e) =>
                                    handleFileForEduDocs(e, "eduDocs", index, row.label,)
                                  }
                                  ref={(el) =>
                                    (fileInputRefs.current[`eduDocs_${index}`] = el)}
                                  style={{ display: "none" }}
                                />
                                <button type="button"
                                  className="btn-interactive 1212"
                                  onClick={() =>
                                    fileInputRefs.current[
                                      `eduDocs_${index}`
                                    ]?.click()
                                  }>
                                  <img className="upload-cta"
                                    src={require("assets/img/upload-icon.png")}
                                    alt="Upload"
                                    style={{
                                      width: 20,
                                      height: 20,
                                    }}
                                  />
                                </button>
                                {docs[uploadType] && (
                                  <a className="view-cta"
                                    href={docs[uploadType]}
                                    target="_blank"
                                    rel="noreferrer"
                                    title="View"
                                  >
                                    <span>View</span>
                                  </a>
                                )}
                                {!educationalDegreeDoc[`eduDocs_${index}`] &&
                                  docError[`eduError_${index}`] && (
                                    <div className="errorMessage text-center w-full text-red-500 text-sm mt-1">
                                      document is required
                                    </div>
                                  )}
                                {!row.fixed && (
                                  <button type="button" onClick={() => removeTableForNextEducationDetail(index)}>
                                    Remove
                                  </button>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className="edu-btn">
                    {eduRows.length < 7 && (
                      <button type="button" className="primary-btn" onClick={addTableForNextEducationDetail}>
                        + Add Other Degree
                      </button>
                    )}
                  </div>
                  <div className="educationSaveButtons">
                    <button type="button" className="contactBackBtn" onClick={() => dispatch(goBack())}>
                      Back
                    </button>
                    <button type="button" className="saveBtn" onClick={handleSaveAsDraft}>
                      Save As Draft
                    </button>
                    <button type="submit" className="saveNextBtn">
                      Save And Next
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}